import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { UserFeedFollowGroupFragment } from 'api';
import { UserAvatar } from 'components';
import { useCurrentUser } from 'hooks';
import * as paths from 'paths';

interface IProps {
  group: UserFeedFollowGroupFragment;
}

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(3),
    cursor: 'pointer',
    userSelect: 'none',
  },
  contentFirst: {
    paddingTop: 12,
  },
}));

const CreatePostBanner: FC<IProps> = ({ group }) => {
  const classes = useStyles();
  const currentUser = useCurrentUser();
  const history = useHistory();
  const { t } = useTranslation();

  function handleClick() {
    history.push({ pathname: paths.postCreate, state: { group } });
  }

  return (
    <Card className={classes.root} onClick={handleClick}>
      <CardContent className={classes.contentFirst}>
        <Grid container alignItems="center" spacing={2}>
          <Grid item>
            <UserAvatar size={40} user={currentUser} />
          </Grid>
          <Grid item xs>
            <Typography variant="subtitle2">{t('posting:prompt')}</Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default CreatePostBanner;
